
export const environment = {
    production: false,
    // Auth-M gateway base URL. `ng serve` uses THIS file, so it points at the
    // local gateway. For the deployed dev site, set this to
    // 'https://dev.pathpedia.com/api'.
    authMUrl: 'https://dev.pathpedia.com/api',
    authMDevHelpers: false,
    authApiUrl: 'https://dev.pathpedia.com/user-management',
    apiURL: 'https://dev.pathpedia.com/user-management',
    baseUrl: 'https://dev.pathpedia.com',
    filesApiUrl: 'https://dev.pathpedia.com/api/upload',
    eAtlasApiUrl: 'https://dev.pathpedia.com/api/imagepedia',
    immunopediaApiUrl: 'https://dev.pathpedia.com/api/immunopedia',
    cdnUrl: 'https://dev.pathpedia.com/gcs',
    mainApiUrl: 'https://dev.pathpedia.com/api/main',
    coreApiUrl: 'https://dev.pathpedia.com/api/core',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY',
};
